import { render, staticRenderFns } from "./dynamic-document-import-template.vue?vue&type=template&id=bbee5bbc&scoped=true&"
import script from "./dynamic-document-import-template.vue?vue&type=script&lang=ts&"
export * from "./dynamic-document-import-template.vue?vue&type=script&lang=ts&"
import style0 from "./dynamic-document-import-template.vue?vue&type=style&index=0&id=bbee5bbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbee5bbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VCol,VProgressCircular,VRow,VStepper,VStepperContent,VStepperStep})
